// 图文课文档的纯函数工具：渲染端第二道防线。
// 服务端已按白名单校验，这里只负责把未知内容安全降级，不做任何 HTML 拼接。

export const KNOWN_BLOCK_TYPES = Object.freeze(['rich_text', 'image', 'video', 'callout', 'divider'])
export const KNOWN_NODE_TYPES = Object.freeze([
  'heading',
  'paragraph',
  'text',
  'list',
  'list_item',
  'blockquote',
  'code'
])

const NODE_TAGS = Object.freeze({
  paragraph: 'p',
  list_item: 'li',
  blockquote: 'blockquote',
  code: 'pre'
})

const BLOCKED_DOCUMENT_KEYS = Object.freeze(['__proto__', 'constructor', 'prototype', 'class'])

function stripPresentationMetadata(value) {
  if (Array.isArray(value)) return value.map(stripPresentationMetadata)
  if (!value || typeof value !== 'object') return value

  return Object.keys(value).reduce((result, key) => {
    if (BLOCKED_DOCUMENT_KEYS.includes(key)) return result
    if (key === 'style') {
      const isNeutralListStyle = value.type === 'list' && (value.style === 'ordered' || value.style === 'unordered')
      if (!isNeutralListStyle) return result
    }
    result[key] = stripPresentationMetadata(value[key])
    return result
  }, {})
}

export function normalizeDocument(document) {
  const blocks = document && Array.isArray(document.blocks) ? document.blocks : []
  return { version: (document && document.version) || 1, blocks: stripPresentationMetadata(blocks) }
}

export function isKnownBlockType(type) {
  return KNOWN_BLOCK_TYPES.includes(type)
}

export function isKnownNodeType(type) {
  return KNOWN_NODE_TYPES.includes(type)
}

export function indexResolvedMedia(list) {
  return (Array.isArray(list) ? list : []).reduce((result, item) => {
    if (item && item.block_id) result[item.block_id] = item
    return result
  }, Object.create(null))
}

export function mediaForBlock(index, block) {
  // block id comes from server content; own-key lookup prevents constructor/prototype inheritance leaks.
  if (!index || !block || !Object.prototype.hasOwnProperty.call(index, block.id)) return { status: 'offline' }
  return index[block.id] || { status: 'offline' }
}

export function nodeTag(node) {
  if (!node || !isKnownNodeType(node.type)) return 'p'
  if (node.type === 'heading') {
    const level = Math.min(4, Math.max(1, Number(node.level) || 2))
    return `h${level}`
  }
  if (node.type === 'list') return node.style === 'ordered' ? 'ol' : 'ul'
  return NODE_TAGS[node.type] || 'p'
}

export function hasMark(node, mark) {
  return !!(node && Array.isArray(node.marks) && node.marks.includes(mark))
}

// 未知节点退化为其纯文本子节点，保证内容不丢、也不执行任何未知结构。
export function nodePlainText(node) {
  if (!node) return ''
  if (node.type === 'text') return node.text || ''
  return (Array.isArray(node.children) ? node.children : []).map(nodePlainText).join('')
}

export function needsContentUpdateAck(detail) {
  return !!(detail && detail.has_content_update && Number(detail.content_update_version) > 0)
}
